import React from 'react';
import { NavigationBarItem } from '../../../../../types/globalSettingsType';
import { useResolvedNavigationLink } from '../../../hooks/useResolvedNavigationLink';
import { useHandleNavigationClick } from '../../../utils/Tracking/Navigation/NavigationTracking';
import * as S from './NavbarLink.styles';

interface NavbarLinkProps {
  item?: NavigationBarItem | null;
}

export const NavbarLink: React.FC<NavbarLinkProps> = ({ item }) => {
  const navbarItemLocation = 'navbarItem';
  const { isInternal, url, blank } = useResolvedNavigationLink({
    data: item?.link?.data,
    type: item?.link?.type,
  });

  const handleOnClick = useHandleNavigationClick({
    event: 'navbarMenuClick',
    menuSectionName: navbarItemLocation,
    menuItemName: item?.header ?? '',
    menuItemUrl: url,
  });

  if (!item?.header || !url) return null;

  if (isInternal) {
    return (
      <S.NavbarLinkButton to={url} onClick={handleOnClick} size="small" textWrap="nowrap">
        {item.header}
      </S.NavbarLinkButton>
    );
  }

  return (
    <S.NavbarLinkButton
      href={url}
      target={blank ? '_blank' : '_self'}
      rel="noopener noreferrer"
      onClick={handleOnClick}
      size="small"
      textWrap="nowrap"
    >
      {item.header}
    </S.NavbarLinkButton>
  );
};
